import { Box } from "@material-ui/core";
import { DataBenefit } from "../../quoteDetail.constants";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { useWhyChooseUsStyles } from "./whyChooseUs.styles";
import { TopBox } from "../../../../components/TopBox";
import { BotBox } from "../../../../components/BotBox";

export const WhyChooseUsSection = ({
  hasSpecialBackground
}: {
  isBoiler?: boolean;
  hasSpecialBackground?: boolean;
}) => {
  const { isMoreThanSm, isMoreThanMd } = useBreakpoint();
  const classes = useWhyChooseUsStyles();
  return (
    <Box
      bgcolor={hasSpecialBackground ? "#f7f7f7" : "#fff"}
      mt={hasSpecialBackground ? "150px" : "104px"}
      position={"relative"}
    >
      {hasSpecialBackground && (
        <TopBox bgColor="#f7f7f7" outsideBgColor="#fff" boxHeight={isMoreThanMd ? "145px" : "71px"} />
      )}
      <Box
        width={isMoreThanSm ? 700 : 340}
        m="auto"
        pt={hasSpecialBackground ? (isMoreThanMd ? "60px" : "120px") : 0}
        className={classes.root}
      >
        <Box
          textAlign="center"
          fontWeight={500}
          fontSize={isMoreThanSm ? 28 : 20}
          color={"#1e073f"}
          marginBottom={isMoreThanSm ? 11 : 6}
          width={"100%"}
          position={hasSpecialBackground ? "absolute" : "relative"}
          top={hasSpecialBackground ? "90px" : "inherit"}
          left={hasSpecialBackground ? 0 : "inherit"}
        >
          Why choose <span className={classes.Swyft}>Swyft Energy</span>
        </Box>
        {DataBenefit.map((item, index) => {
          return (
            <Box key={index}>
              <Box display="flex" flexWrap={isMoreThanSm ? "nowrap" : "wrap"}>
                <Box paddingRight={isMoreThanSm ? 5 : 0} mb={isMoreThanSm ? 0 : 3} m={isMoreThanSm ? "" : "auto"}>
                  <img src={item.src} width={80} alt={item.title} />
                </Box>
                <Box textAlign={isMoreThanSm ? "" : "center"}>
                  <Box fontSize={isMoreThanSm ? 19 : 18} fontWeight={500} mb={1} color={"#1e073f"}>
                    {item.title}
                  </Box>
                  <Box fontSize={isMoreThanSm ? 16 : 14} mb={7} color="#4b5462">
                    {item.description}
                  </Box>
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
      {hasSpecialBackground && (
        <BotBox bgColor="#f7f7f7" outsideBgColor="#fff" boxHeight={isMoreThanMd ? "145px" : "71px"} />
      )}
    </Box>
  );
};
